import NameSelector from "./NameSelector";
import { fenders } from "./data/config";

const Fenders = ({ selectedFender, selectFender }) => {
    const handleSelectFender = (fender) => () => {
        selectFender(fender);
    }
    
    return (
        <div>
            <h3 className='section-title !mb-3'>Fenders</h3>
            <div className='flex gap-4'>
                {fenders.map((fender) => {
                    return <NameSelector 
                        key={fender.name} 
                        name={fender.name} 
                        onClick={handleSelectFender(fender)} 
                        selected={fender.id === selectedFender.id}
                    />
                })}
            </div>
        </div>
    )
}

export default Fenders;